export default function vatInPlatform(platform: any) {
  if (platform.Price) return platform.Price.vat;

  return null;
}
